import * as React from "react";
import { quotationFormStyles } from "./QuotationForm.styles";
import { Grid, Typography, WithStyles } from "@material-ui/core";
import { UiFormBuilder } from "../../utils/UiFormBuilder";
import { UpdateRequestBuilder } from "../../utils/UpdateRequestBuilder";
import { Form } from "../../types/Form";
import { Products, ProductVariantName } from "../../types/Products";
import {
    ProductGO,
    productGOContributionMethods,
    productGOBeneficiaryClauseItems,
    productGOContributionTemporaryValue,
    productGOPvoFormulas,
    productGOTypes,
    productGOSamplingIntervals,
} from "../../types/ProductGO";
import { Beneficiary } from "../../types/Beneficiary";
import Contribution from "../Contribution/Contribution";
import InputRadio from "../InputRadio/InputRadio";
import InputSelect from "../InputSelect/InputSelect.component";
import InputCheckbox from "../InputCheckbox/InputCheckbox";
import QuotationFormBeneficiaries from "./QuotationFormBeneficiaries";
import { Quotation } from "../../types/Quotation";
import { Customer } from "../../types/Customer";
import { ProductGOHelper } from "../../helper/ProductGO.helper";

interface QuotationProductGOProps extends WithStyles<typeof quotationFormStyles> {
    mode?: "calculator";
    productHelper: ProductGOHelper;
    productVariantName: ProductVariantName;
    customer: Customer;
    quotation: Quotation;
    showError(message: string);
    hideError();
    onChange(product: Products);
}

type QuotationProductGOState = {
    form: Form<Products>;
};

class QuotationFormProductGO extends React.Component<QuotationProductGOProps, QuotationProductGOState> {
    private formBuilder = null;

    public async componentWillMount() {
        this.updateState(this.props);
    }

    public componentWillReceiveProps(nextProps: QuotationProductGOProps) {
        this.props.productHelper.setCustomer(nextProps.customer);
        this.props.productHelper.setQuotation(nextProps.quotation);
        this.updateState(nextProps);
    }

    public onChange(fieldName: string, value: any) {
        const builder = new UpdateRequestBuilder();
        builder.set(`values.${fieldName}`, value);
        if (fieldName === "contributionMethod" && value === "unique") {
            builder.set(`values.samplingInterval`, null);
        }
        let form = builder.exec(this.state.form);
        this.setState({ form: form });
        this.props.onChange(form.values);
    }

    public onChangeBeneficiaries(beneficiaries: Beneficiary[]) {
        let product = this.props.quotation.product as ProductGO;
        product.beneficiaries = beneficiaries;
        this.props.onChange(product);
    }

    public render() {
        if (!this.state || !this.props.customer || !this.props.customer.birthdate) {
            return null;
        }

        const uiForm = this.formBuilder.build(this.state.form);
        const product: ProductGO = this.props.quotation.product as ProductGO;

        return (
            <>
                {/* Mode de prélèvement */}

                <div className={this.props.classes.box}>
                    <Typography
                        variant={this.props.mode === "calculator" ? "headline" : "title"}
                        gutterBottom={true}
                        className={this.props.classes.formTitle}
                    >
                        {this.props.mode === "calculator" ? "Mode de prélèvement" : "4/ Mode de prélèvement"}
                    </Typography>
                    <Grid container={true} spacing={16}>
                        <Grid item={true}>
                            <InputRadio {...uiForm.fields.contributionMethod} />
                        </Grid>
                        <Grid item={true} style={{ marginTop: "22px" }}>
                            <InputSelect {...uiForm.fields.contributionTemporaryValue} />
                        </Grid>
                        <Grid item={true} sm={12}>
                            <InputRadio {...uiForm.fields.samplingInterval} />
                        </Grid>
                    </Grid>
                </div>

                {/* Garanties */}

                <div className={this.props.classes.box}>
                    <Typography
                        variant={this.props.mode === "calculator" ? "headline" : "title"}
                        gutterBottom={true}
                        className={this.props.classes.formTitle}
                    >
                        {this.props.mode === "calculator" ? "Garanties" : "5/ Garanties"}
                    </Typography>
                    <Grid container={true} spacing={16} className={this.props.classes.guarantyBoxBackground}>
                        <Grid item={true} sm={12}>
                            <InputRadio
                                {...uiForm.fields.type}
                                style={{ display: "flex", justifyContent: "space-between" }}
                            />
                        </Grid>
                        {product && product.type === "pco" ? (
                            <Grid item={true} sm={4}>
                                <InputSelect {...uiForm.fields.pcoGuaranteedCapitalAmount} />
                            </Grid>
                        ) : null}
                        {product && product.type === "pvo" ? (
                            <Grid item={true} sm={12}>
                                <InputRadio {...uiForm.fields.pvoFormula} />
                            </Grid>
                        ) : null}
                    </Grid>
                </div>

                {/* Cotisation */}

                {product && product.contribution ? (
                    <div className={this.props.classes.box}>
                        <Typography
                            variant={this.props.mode === "calculator" ? "headline" : "title"}
                            gutterBottom={true}
                            className={this.props.classes.formTitle}
                        >
                            {this.props.mode === "calculator" ? "Cotisations" : "6/ Cotisations"}
                        </Typography>
                        <div className={this.props.classes.cotisationsBoxResume}>
                            <Typography variant="display3" className={this.props.classes.cotisationsBoxResumeItem}>
                                <b>RÉSUMÉ</b>
                            </Typography>
                            <Typography variant="display3" className={this.props.classes.cotisationsBoxResumeItem}>
                                Votre cotisation s'élève à{" "}
                                <Contribution
                                    value={this.props.productHelper.getPeriodicContribution()}
                                    interval={product.samplingInterval}
                                />
                                {product.contributionMethod !== "unique" ? " assistance incluse" : ""}
                            </Typography>
                        </div>
                    </div>
                ) : null}

                {/* Bénéficiaire */}

                {this.props.mode !== "calculator" && product && product.type === "pvo" && product.contribution ? (
                    <div className={this.props.classes.box}>
                        <Typography variant="title" gutterBottom={true} className={this.props.classes.formTitle}>
                            7/ Bénéficiaires
                        </Typography>
                        <Grid container={true} spacing={16}>
                            <Grid item={true} sm={12}>
                                <InputCheckbox
                                    label="L'opérateur funéraire : la SA UDIFE Le Choix Funéraire."
                                    value={true}
                                    disabled={true}
                                />
                                <Typography variant="caption">
                                    Le solde du capital éventuel restant après le règlement des frais d'obsèques
                                    reviendra à mon conjoint, à défaut mes héritiers.
                                </Typography>
                            </Grid>
                        </Grid>
                    </div>
                ) : null}

                {this.props.mode !== "calculator" && product && product.type === "pco" && product.contribution ? (
                    <div className={this.props.classes.box}>
                        <Typography variant="title" gutterBottom={true} className={this.props.classes.formTitle}>
                            7/ Bénéficiaires
                        </Typography>
                        <Grid container={true} spacing={16}>
                            <Grid item={true} sm={12}>
                                <InputRadio {...uiForm.fields.beneficiaryClause} />
                            </Grid>
                            {product.beneficiaryClause === "beneficiary" ? (
                                <Grid item={true} sm={12}>
                                    <QuotationFormBeneficiaries
                                        classes={this.props.classes}
                                        withQuoteParts={true}
                                        beneficiaries={product.beneficiaries}
                                        onChange={this.onChangeBeneficiaries.bind(this)}
                                    />
                                </Grid>
                            ) : null}
                        </Grid>
                    </div>
                ) : null}
            </>
        );
    }

    private updateState(nextProps: QuotationProductGOProps) {
        const product = this.updateProduct(nextProps);

        this.formBuilder = new UiFormBuilder<Products>();

        this.formBuilder

            // Type

            .addField("type", {
                props: {
                    items: productGOTypes,
                    disabled: true,
                },
            })
            .addField("pcoGuaranteedCapitalAmount", {
                props: {
                    label: "Montant du capital garanti",
                    items: this.props.productHelper.getPCOGuaranteedCapitalAmountItems(),
                    required: true,
                },
            })
            .addField("pvoFormula", {
                props: {
                    label: "Sélectionnez une formule :",
                    items: productGOPvoFormulas,
                    required: true,
                },
            })
            .addField("monthlyContribution", {
                props: {
                    disabled: true,
                    description: "/ans",
                },
            })
            .addField("contributionMethod", {
                props: {
                    label: "Mode de cotisation :",
                    items: productGOContributionMethods,
                },
            })
            .addField("contributionTemporaryValue", {
                props: {
                    description: "ans",
                    disabled: !product || product.contributionMethod !== "temporary",
                    items: productGOContributionTemporaryValue,
                },
            })
            .addField("samplingInterval", {
                props: {
                    label: "Mode de prélèvement :",
                    disabled: product && product.contributionMethod === "unique",
                    items: productGOSamplingIntervals,
                },
            })

            // Clause

            .addField("beneficiaryClause", {
                props: {
                    name: "beneficiaryClause",
                    items: productGOBeneficiaryClauseItems,
                    required: true,
                },
            });

        this.formBuilder.onChange(this.onChange.bind(this));

        this.setState({
            form: {
                fields: {},
                errors: [],
                values: product,
            },
        });
    }

    private updateProduct(props) {
        let product = props.quotation.product as ProductGO;

        switch (product.contributionMethod) {
            case "unique":
                product.samplingInterval = null;
                break;
            default:
                product.contributionMethod = product.contributionMethod || "temporary";
                product.samplingInterval = product.samplingInterval || "month";
                product.contributionTemporaryValue = product.contributionTemporaryValue || "5";
                break;
        }

        let quotation = { ...props.quotation, product };
        this.props.productHelper.setQuotation(quotation); // TODO: find a better way

        product.type = this.props.productVariantName === "PCO" ? "pco" : "pvo";

        try {
            // Manage pvo
            if (product && product.type && product.type === "pco" && product.pcoGuaranteedCapitalAmount) {
                product.contribution = this.props.productHelper.getPCOContribution();
            }

            // Manage pco
            if (product && product.type && product.type === "pvo" && product.pvoFormula) {
                product.contribution = this.props.productHelper.getPVOContribution();
            }

            this.props.hideError();
        } catch (e) {
            this.props.showError(e.message);
        }

        return product;
    }
}

export default QuotationFormProductGO;



// WEBPACK FOOTER //
// ./src/components/QuotationForm/QuotationFormProductGO.tsx